import { render, staticRenderFns } from "./PackageUpload.vue?vue&type=template&id=224e9105&scoped=true"
import script from "./PackageUpload.vue?vue&type=script&lang=js"
export * from "./PackageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224e9105",
  null
  
)

export default component.exports